<template>
    <v-data-table
        :headers="monthHeader"
        :items="budgetDetails"
        item-key="item.title"
        class="elevation-1 table"
        :hide-default-footer="true"
    >
        <template v-slot:item="props">
            <tr v-if="!props.item.isTotal" colspan="headers.length">
                <td class="text-left">
                    <v-edit-dialog
                        v-if="props.item.editable"
                        v-model:return-value="props.item.title"
                        >{{ props.item.title }}
                        <template v-slot:input>
                            <v-text-field-filled v-model="props.item.title" single-line />
                        </template>
                    </v-edit-dialog>
                    <div v-else>
                        {{ props.item.title }}
                    </div>
                </td>
                <td
                    v-for="month of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]"
                    :key="month"
                    class="text-left"
                >
                    <div v-if="props.item.editable">
                        <span
                            :style="
                                props.item.budget[month].hasBeenManuallyModified
                                    ? 'color:orange'
                                    : ''
                            "
                            v-if="displayMenu[props.item.title + ' ' + month] === false"
                            :key="keyRefresh"
                            @click="
                                displayMenu[props.item.title + ' ' + month] = true;
                                keyRefresh++;
                            "
                        >
                            {{ props.item.budget[month].amountSigned }}
                        </span>
                        <v-menu
                            v-else
                            :close-on-click="false"
                            :close-on-content-click="false"
                            :key="keyRefresh"
                            v-model="displayMenu[props.item.title + ' ' + month]"
                        >
                            <template v-slot:activator="{ props }">
                                <span
                                    :style="
                                        props.item.budget[month].hasBeenManuallyModified
                                            ? 'color:orange'
                                            : ''
                                    "
                                    v-bind="props"
                                >
                                    {{ props.item.budget[month].amountSigned }}
                                </span>
                            </template>
                            <v-card class="d-flex pa-0 ma-0 elevation-0">
                                <oss-text-field
                                    outlined
                                    dense
                                    single-line
                                    class="d-flex my-2 mr-2 float-left align-end"
                                    hide-details
                                    @change="updateData(props.item, month)"
                                    v-model="props.item.budget[month].amountSigned"
                                />
                                <v-tooltip location="bottom">
                                    <template v-slot:activator="{ props }">
                                        <v-icon
                                            class="d-flex mt-2"
                                            @click="
                                                displayMenu[props.item.title + ' ' + month] = false;
                                                keyRefresh++;
                                            "
                                            size="small"
                                            location="end"
                                            v-bind="props"
                                            >$oss-circle-check
                                        </v-icon>
                                    </template>
                                    <span>Valider</span>
                                </v-tooltip>
                                <v-tooltip location="bottom">
                                    <template v-slot:activator="{ props }">
                                        <v-icon
                                            class="d-flex mt-2"
                                            @click="duplicateRightAll(props.item, month)"
                                            size="small"
                                            location="end"
                                            v-bind="props"
                                            >$oss-duplicate
                                        </v-icon>
                                    </template>
                                    <span>Dupliquer sur les cellules de droite</span>
                                </v-tooltip>
                            </v-card>
                        </v-menu>
                        <!-- <v-edit-dialog
                            v-model:return-value="props.item.budget[month].amountSigned"
                            class="d-flex pa-2"
                            >
                            <span :style="props.item.budget[month].hasBeenManuallyModified ? 'color:orange' : ''">
                                {{ props.item.budget[month].amountSigned }}
                            </span>
                            <template v-slot:input>
                                <td>
                                    <oss-text-field
                                        v-model.number="props.item.budget[month].amountSigned"
                                        type="number"
                                        outlined
                                        dense
                                        single-line
                                        class="d-flex my-2 mr-2 float-left align-end oss-"
                                        hide-details
                                        @change="updateData(props.item, month)"
                                    ></oss-text-field>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on: tooltip }">
                                            <v-icon
                                                right
                                                 size="small"
                                                class="d-flex mt-2"
                                                @click="open = false"
                                                v-on="{...tooltip}"
                                                >$oss-circle-check
                                            </v-icon>
                                        </template>
                                        <span>Valider</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on: tooltip }">
                                            <v-icon
                                                right
                                                 size="small"
                                                class="d-flex mt-2"
                                                @click="duplicateRightAll(props.item, props.index, month), open = false"
                                                v-on="{...tooltip}"
                                                >$oss-duplicate
                                            </v-icon>
                                        </template>
                                        <span>Dupliquer sur les cellules de droite</span>
                                    </v-tooltip>
                                </td>
                            </template>
                        </v-edit-dialog> -->
                    </div>
                    <div v-else>
                        {{ props.item.budget[month].amountSigned }}
                    </div>
                </td>
                <td>
                    <!-- <v-btn
                        color="primary"

                        rounded
                        :disabled="props.index < 3"
                        elevation="0"
                        @click="deleteLine(props.index)"
                        >Supprimer
                    </v-btn> -->
                    <v-icon
                        :disabled="props.index < 3"
                        @click="deleteLine(props.index)"
                        size="small"
                    >
                        $oss-trash
                    </v-icon>
                </td>
            </tr>
            <tr v-if="props.item.isTotal">
                <td class="text-left">
                    {{ props.item.title }}
                </td>
                <td
                    v-for="month of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]"
                    :key="props.item.budget[month].date"
                    class="text-left"
                >
                    {{ props.item.budget[month].amountSigned }}
                </td>
                <td>
                    <v-icon
                        :disabled="props.index < 3"
                        @click="deleteLine(props.index)"
                        size="small"
                    >
                        $oss-trash
                    </v-icon>
                </td>
            </tr>
        </template>
        <template v-slot:[`body.append`]="{ columns }">
            <tr>
                <td :colspan="columns.length - 1">
                    <v-btn rounded="circle" elevation="0" @click="addBlankLine()" size="small">
                        +
                    </v-btn>
                    <!-- <v-icon
                         size="small"
                        @click="addBlankLine()"
                    >
                        plus
                    </v-icon> -->
                </td>
                <!-- <td :colspan="1">
                    <v-btn
                        color="primary"

                        rounded
                         size="small"
                        elevation="0"
                        @click="emitUpsertOrder()"
                        >Enregistrer
                    </v-btn>
                    <v-icon
                        @click="upsertBudget()"
                    >
                        save_content_outline
                    </v-icon>
                </td> -->
            </tr>
        </template>
    </v-data-table>
</template>

<script lang="ts">
import { State2Way } from "@/decorators";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["computeAmountN"],
})
export class BudgetDetails extends Vue {
    @Prop({ default: null }) id: string;
    @Prop({ default: null }) accountableAccount: any;
    @Prop({
        default: [
            "Janv",
            "Févr",
            "Mars",
            "Avr",
            "Mai",
            "Juin",
            "Juil",
            "Aout",
            "Sept",
            "Oct",
            "Nov",
            "Déc",
        ],
    })
    monthList: any[];
    @Prop({ default: {} }) displayMenu: any;

    @State2Way("updateSelectedAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    selectedAccountingPeriod!: any;

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get monthHeader() {
        return [
            { title: "Titre", value: "title" },
            { title: this.monthList[0], value: "budget[0].amountSigned" },
            { title: this.monthList[1], value: "budget[1].amountSigned" },
            { title: this.monthList[2], value: "budget[2].amountSigned" },
            { title: this.monthList[3], value: "budget[3].amountSigned" },
            { title: this.monthList[4], value: "budget[4].amountSigned" },
            { title: this.monthList[5], value: "budget[5].amountSigned" },
            { title: this.monthList[6], value: "budget[6].amountSigned" },
            { title: this.monthList[7], value: "budget[7].amountSigned" },
            { title: this.monthList[8], value: "budget[8].amountSigned" },
            { title: this.monthList[9], value: "budget[9].amountSigned" },
            { title: this.monthList[10], value: "budget[10].amountSigned" },
            { title: this.monthList[11], value: "budget[11].amountSigned" },
            { title: "Actions" },
        ];
    }

    skip: boolean = false;

    amountsList = [];

    keyRefresh = 0;

    get budgetDetails() {
        return this.accountableAccount.amounts;
    }

    setDisplayFalse() {
        for (const amountsLine of this.budgetDetails) {
            for (let month = 0; month < 12; month++) {
                this.displayMenu[amountsLine.title + " " + month] = false;
            }
        }
    }

    // buildDisplayMenu(){
    //     for(const amountsLine of this.budgetDetails) {
    //         for (let month = 0; month < 12; month++) {
    //             this.displayMenu[amountsLine.title + " " + month] = false;
    //         }
    //     }
    // }

    addBlankLine() {
        // semi WARN INDEX, because it only need the line to exist, no matter the values of it
        // generate a blank line in the expandable element
        // functionalities will come later to fill the created line
        if (!this.budgetDetails) {
            debugger;
            return;
        }
        let blankLine = JSON.parse(JSON.stringify(this.budgetDetails[1])); // why taking index 1 instead of another ?
        blankLine.title = "Nouvelle ligne";
        blankLine.isBaseForCalculation = false;
        blankLine.editable = true;
        blankLine.isTotal = false;
        for (const value of blankLine.budget) {
            value.amountSigned = 0;
            value.hasBeenManuallyModified = false;
        }
        this.budgetDetails.push(blankLine);
        this.computeAmountN();
    }

    updateBudgetN(item) {
        // WARN INDEX
        // generate the line of the current year according to the selected generation method
        if (item.generationMethod.mode === "pourc") {
            this.budgetYearByPercentage(item);
        } else if (item.generationMethod.mode === "mont") {
            this.budgetByAmount(item);
        } else if (item.generationMethod.mode === "affi") {
            this.budgetByAffine(item);
        }
        this.computeAmountN();
    }

    budgetYearByPercentage(item) {
        // WARN INDEX
        // Knowing amountNM1, construct amountN by multiplicating by the coefficient
        // in case of a percentage generation, apply the value of year NM1 multiplied by the given coefficient
        // the input value corresponds to a growth percentage, ie if the user give 20, the corresponding coeff will be 1.20
        // thus the parameter generationMethod.value is a value between -100 and infinite
        const previousAmount = JSON.parse(JSON.stringify(item.amounts[1].budget));
        let coefficient = item.generationMethod.value / 100 + 1;
        for (let month = 0; month < 12; month++) {
            const amount = (previousAmount[month].amountSigned * coefficient).toFixed(2);
            item.amounts[2].budget[month].amountSigned = amount;
        }
    }

    budgetByAmount(item) {
        // WARN INDEX
        // in case of an amount generation, split the given amount equally between the 12 months
        const amount = (item.generationMethod.value / 12).toFixed(2);
        for (let month = 0; month < 12; month++) {
            item.amounts[2].budget[month].amountSigned = amount;
        }
    }

    budgetByAffine(item) {
        // WARN INDEX
        // in case of adding to the previous amount another amount, which can be positive or negative
        const amount = JSON.parse(JSON.stringify(item.amounts[1].budget));
        for (let month = 0; month < 12; month++) {
            item.amounts[2].budget[month].amountSigned =
                amount[month].amountSigned + item.generationMethod.value;
        }
    }

    updateData(amountsLine, month) {
        debugger;
        this.computeAmountN();
        this.isModified(amountsLine, month);
    }

    computeAmountN() {
        // params : item
        // item : line of amounts
        // WARN INDEX
        let resultN = 0;
        let monthByMonth = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        let amounts = this.budgetDetails;
        for (let lineIndex = 2; lineIndex < amounts.length; lineIndex++) {
            let budgetN = amounts[lineIndex].budget;
            for (let monthIndex in budgetN) {
                monthByMonth[monthIndex] += parseFloat(budgetN[monthIndex].amountSigned);
            }
        }
        for (const monthIndex in monthByMonth) {
            resultN += monthByMonth[monthIndex];
            amounts[0].budget[monthIndex].amountSigned = monthByMonth[monthIndex];
        }
        this.$emit("computeAmountN", resultN.toFixed(2));
        return monthByMonth;
    }

    deleteLine(lineIndex) {
        // params : lineIndex stands for the index of the budget line to delete in the list amounts
        // find the right accountable account in monthly6And7Balances then delete the right line of it
        this.budgetDetails.splice(lineIndex, 1);
        this.computeAmountN();
    }

    findBudgetLine(title) {
        for (let lineIndex = 0; lineIndex < this.budgetDetails.length; lineIndex++) {
            if (this.budgetDetails[lineIndex].title === title) {
                return lineIndex;
            }
        }
        return null;
    }

    isModified(amountsLine, month) {
        amountsLine.budget[month].hasBeenManuallyModified = true;
    }

    duplicateRightAll(amountsLine, month) {
        debugger;
        const amountToDuplicate = amountsLine.budget[month].amountSigned;
        for (let furtherMonth = month + 1; furtherMonth < 12; furtherMonth++) {
            amountsLine.budget[furtherMonth].amountSigned = amountToDuplicate;
            this.updateData(amountsLine, month);
        }
        this.displayMenu[amountsLine.title + " " + month] = false;
        this.keyRefresh++;
    }

    // emitUpsertOrder() {
    //     this.$emit('on-budget-saved');
    // }
}

export default toNative(BudgetDetails);
</script>
